// @flow
import * as React from 'react'
import type { FormApi } from 'final-form'

export default React.createContext<?FormApi<any>>()
